export const searchCopy = {
  title: "Find Your Company in the {count} Audit Database",
  placeholder: "[ Enter your Company Name... (e.g., Apex Roofing) ]",
  button: "Search",
  foundCta: "STANCH THIS LEAKAGE — RUN LIVE TEST NOW",
  missingTitle: "Company Not Found in the Initial {count} Benchmark Batch",
  missingBody:
    "Your business was not included in our initial blind audit. Run a Live 60-Second Speed Audit on your website right now for FREE:",
  domainLabel: "Your Website Domain",
  domainPlaceholder: "e.g. myroofing.com",
  phoneLabel: "Your Direct Mobile Phone",
  phonePlaceholder: "+1 (555) 000-0000",
  missingCta: "PREVENT THE LEAD LEAKAGE — BE IN TOP 0.12% OF ROOFING INDUSTRY",
}
